export default __webpack_public_path__ + "svg/calendar/2026/5/mayo.svg?ff6b19dd";